import { Grid, Icon, Modal, Spacer } from "@cd2/components"
import { H2 } from "@cd2/text"
import React from "react"
import { uniq } from "../../utils/utils"
import { ConfirmCancelButtons } from "../../Components/Buttons/ConfirmCancelButtons"
import { icons } from "../../constants/icons"
import { brandColors } from "../../Components/EOSThemeProvider"

interface ISaveWarningModalProps {
  data: {
    warnings: string[]
  }

  onResolve(data: boolean | { preview: boolean }): void
}

export function SaveWarningModal({ onResolve, data }: ISaveWarningModalProps) {
  const errorMessages = uniq(data.warnings)

  return (
    <Modal
      isOpen={true}
      onRequestClose={() => onResolve(false)}
      render={() => (
        <div>
          <H2 blockSpacing={0.5}>
            {errorMessages.length === 1 ? "Warning" : `There are ${errorMessages.length} warnings`}
          </H2>
          <Grid gap={12}>
            {errorMessages.map(msg => (
              <div key={msg}>
                <Icon icon={icons.alert} color={brandColors.blaze} swapOpacity />
                <span style={{ paddingLeft: "6px" }}>{msg}</span>
              </div>
            ))}
          </Grid>
          <Spacer size={16} />
          <div>
            <ConfirmCancelButtons
              onConfirm={() => onResolve(true)}
              onCancel={() => onResolve(false)}
              buttonOpts={{ confirm: { children: "Continue" } }}
            />
          </div>
        </div>
      )}
    />
  )
}
